/**
 * Shared helpers for Pallet Management UI.
 */
export const fmt$ = (n) => `$${(Number(n) || 0).toFixed(2)}`;
export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString() : '—');
export const fmtDateTime = (v) =>
  v ? new Date(v).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' }) : '—';

export const KIND_LABELS = {
  in: 'IN',
  out: 'OUT',
  transfer_in: 'Transfer in',
  transfer_out: 'Transfer out',
  exchange_in: 'Exchange in',
  exchange_out: 'Exchange out',
  adjustment: 'Adjustment',
  loss: 'Loss',
  damage: 'Damage',
};

export const KIND_TONE = {
  in: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  out: 'bg-rose-50 text-rose-700 border-rose-200',
  transfer_in: 'bg-sky-50 text-sky-700 border-sky-200',
  transfer_out: 'bg-sky-50 text-sky-700 border-sky-200',
  exchange_in: 'bg-violet-50 text-violet-700 border-violet-200',
  exchange_out: 'bg-violet-50 text-violet-700 border-violet-200',
  adjustment: 'bg-amber-50 text-amber-700 border-amber-200',
  loss: 'bg-rose-100 text-rose-900 border-rose-300',
  damage: 'bg-orange-100 text-orange-900 border-orange-300',
};

export const isPositiveKind = (k) =>
  ['in', 'transfer_in', 'exchange_in', 'adjustment'].includes(k);
